import { Employee } from "../../types";
import { chiaveSede, contieneTesto } from "../certificate/pipeline";

/*
 Ricerca libera sul dipendente per cognome e nome, usata dall'anagrafica e dalla finestra con
 cui si aggiungono o si prenotano i partecipanti. La regola e' quella della scheda del corso
 prenotato e della ricerca sul discente negli attestati: `contieneTesto` sui due ordini, cosi'
 "matteo pera" trova PERA MATTEO e "SALVINI" trova Salvini.

 Nome o cognome possono mancare: si leggono come stringa vuota, altrimenti il modello di stringa
 li scriverebbe "undefined" e il confronto li troverebbe cercando quella parola.
 Testo vuoto: nessun filtro.
*/
export function filtraPerNome(
  dipendenti: Employee[],
  testo: string,
): Employee[] {
  if (!testo) return dipendenti;
  return dipendenti.filter((dipendente) => {
    const cognome = dipendente.lastName ?? "";
    const nome = dipendente.firstName ?? "";
    return (
      contieneTesto(`${cognome} ${nome}`, testo) ||
      contieneTesto(`${nome} ${cognome}`, testo)
    );
  });
}

/*
 Filtro per sede di lavoro, usato dall'anagrafica e dalla finestra con cui si aggiungono o si
 prenotano i partecipanti. La tendina di tutte e due nasce da `initHeadquartersFilterEmployee`,
 che offre la sede normalizzata da `chiaveSede`: il confronto normalizza percio' anche il dato,
 cosi' una voce trova i dipendenti di tutte le varianti di scrittura della stessa sede.

 La sede di lavoro puo' mancare (il backend la consegna `null`): `chiaveSede` la legge come
 stringa vuota, e il dipendente senza sede non corrisponde a nessuna voce invece di far
 esplodere il filtro. La voce "tutte" non arriva qui: la riconosce il chiamante.
*/
export function filtraPerSedeDiLavoro(
  dipendenti: Employee[],
  sede: string,
): Employee[] {
  const chiave = chiaveSede(sede);
  return dipendenti.filter((dipendente) =>
    chiaveSede(dipendente.workplace).includes(chiave),
  );
}
